import { useTranslation } from "react-i18next";
import { BsCalendar2Date } from "react-icons/bs";
import ToggleDrawer from "../../contexts/ToggleDrawer";
import usePrimaryColor from "../../hooks/usePrimaryColor";
import BookingModal from "../modals/bookingModalComponents/components/BookingModal";
import BookingModalContext from "../modals/bookingModalComponents/context/BookingModalContext";
import CustomDialog from "../wrappers/CustomDrawer";
import NoClinicWrapper from "../wrappers/NoClinicWrapper";
import FullScreenMessageCore from "./FullScreenMessageCore";

export default function CreateAppointmentFullScreenMessage({
  centerRelative = false,
}) {
  const { t } = useTranslation();
  const color = usePrimaryColor();

  return (
    <FullScreenMessageCore
      icon={<BsCalendar2Date size={150} color={color} />}
      title={"NoAppointments"}
      centerRelative={centerRelative}
    >
      <NoClinicWrapper>
        <ToggleDrawer>
          <CustomDialog
            buttonType={"contained"}
            sx={{ bgcolor: "white" }}
            buttonMessage={t("Book")}
            buttonSize={"large"}
            maxWidth={"lg"}
          >
            <BookingModalContext key={"service-booking-context"}>
              <BookingModal key={"service-booking-modal"} />
            </BookingModalContext>
          </CustomDialog>
        </ToggleDrawer>
      </NoClinicWrapper>
    </FullScreenMessageCore>
  );
}
